import { render } from "./LecturerIntegral.vue?vue&type=template&id=5807e1eb&scoped=true"
import script from "./LecturerIntegral.vue?vue&type=script&lang=js"
export * from "./LecturerIntegral.vue?vue&type=script&lang=js"

import "./LecturerIntegral.vue?vue&type=style&index=0&id=5807e1eb&lang=less&scoped=true"

import exportComponent from "F:\\ypx\\zhiniao\\zhiniao-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5807e1eb"]])

export default __exports__